export default __webpack_public_path__ + "static/media/Commanding-Comprehension-Nate-Baldwin.f436c28d.jpg";